module.exports = __webpack_public_path__ + "img/arrow-down.506b19bd.svg";